<script setup lang="ts">
/**
 * One ruled settings row: label and description on the left, the control
 * right-aligned so every control on a page lines up. `stacked` puts the
 * control under the label (for wide controls); `nested` indents the row under
 * the setting that reveals it. The `below` slot spans the full row width.
 * `platform` keeps it to the desktop or the phone app only.
 */
import { onThisPlatform, type AppPlatform } from '../../../utils/appVariant'

withDefaults(defineProps<{
  label?: string
  description?: string
  stacked?: boolean
  nested?: boolean
  disabled?: boolean
  platform?: AppPlatform
}>(), {
  label: '',
  description: '',
})
</script>

<template>
  <div v-if="onThisPlatform(platform)" class="s-row" :class="{ stacked, nested, 'is-disabled': disabled }">
    <div class="s-row-info">
      <div v-if="label || $slots.label" class="s-row-label">
        <slot name="label">{{ label }}</slot>
        <slot name="label-extra" />
      </div>
      <div v-if="description || $slots.description" class="s-row-desc">
        <slot name="description">{{ description }}</slot>
      </div>
    </div>
    <div v-if="$slots.default" class="s-row-control">
      <slot />
    </div>
    <div v-if="$slots.below" class="s-row-below">
      <slot name="below" />
    </div>
  </div>
</template>
